var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFiTrash2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44141 4.29443H3.6767H13.5591",
    stroke: "white",
    strokeWidth: 1.15294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52872 4.29432V3.05902C5.52872 2.7314 5.65887 2.4172 5.89053 2.18554C6.12219 1.95388 6.4364 1.82373 6.76402 1.82373H9.2346C9.56223 1.82373 9.87643 1.95388 10.1081 2.18554C10.3398 2.4172 10.4699 2.7314 10.4699 3.05902V4.29432M12.3228 4.29432V12.9414C12.3228 13.269 12.1927 13.5832 11.961 13.8149C11.7294 14.0465 11.4152 14.1767 11.0875 14.1767H4.91108C4.58345 14.1767 4.26925 14.0465 4.03759 13.8149C3.80593 13.5832 3.67578 13.269 3.67578 12.9414V4.29432H12.3228Z",
    stroke: "white",
    strokeWidth: 1.15294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23438 7.38232V11.0882",
    stroke: "white",
    strokeWidth: 1.15294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76367 7.38232V11.0882",
    stroke: "white",
    strokeWidth: 1.15294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTrash2);
export default __webpack_public_path__ + "static/media/fi_trash-2.9efb3f34cb9dce73eccafbd728a50e25.svg";
export { ForwardRef as ReactComponent };